<style>
#varianceCardModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 400px !important;
}
#varianceCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#varianceCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#varianceCardModal .v-select__selection {
  font-size: 12px !important;
}
#varianceCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#varianceCardModal .v-tabs {
  width: 100%;
}
.btnDisabled {
  pointer-events: none !important;
  color: rgb(136, 136, 136) !important;
}
</style>

<template>
  <!-- TODO zmiana module po dostosowaniu backendu -->
  <Modal
    modalName="varianceCardModal"
    title="KARTA ROZBIEŻNOŚCI"
    @opened="loadData(), transformPolyCoords(), updateList(), getVariancesStatus(), getVariancesType(), getUsers()"
    @closed="closed()"
    :buttons="['']"
    :editing="editing"
    :module="module"
    @editingStart="startEditing()"
    @editingSave="saveEditing()"
    @editingCancel="cancelEditing()"
  >
    <div
      v-if="currentVariance.hasOwnProperty('properties')"
      style="height:100%;"
    >
      <v-layout
        xs12
        class="font--primary"
        style="height:100%;"
      >
        <v-tabs
          color="#2a579a"
          dark
          centered
          grow
          active-class="tab--active"
          :hide-slider="true"
          height="35"
        >
          <v-tab>ATRYBUTY</v-tab>
          <v-tab-item>
            <v-card
              flat
              id="attr__wrapper"
            >
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-subheader>PODSTAWOWE INFORMACJE O ROZBIEŻNOŚCI</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrawp
              >
                <v-flex xs5>
                  <v-text-field
                    v-model="currentVariance.properties.name"
                    label="Nazwa"
                    :readonly="!editing"
                  ></v-text-field>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-select
                    :items="users"
                    item-text="name"
                    item-value="id"
                    no-data-text="Brak użytkowników"
                    v-model="currentVariance.properties.created_by"
                    :readonly="!editing"
                    label="Identyfikator/nazwa inspektora wykonującego inspekcję"
                    :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs5>
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :readonly="!editing"
                  >
                    <template
                      :readonly="!editing"
                      v-slot:activator="{ on }"
                    >
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Data inspekcji"
                        prepend-icon="event"
                        :readonly="!editing"
                        @input="currentVariance.properties.created_at = parseDate(computedDateFormatted)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="currentVariance.properties.created_at"
                      @input="dateMenu = false"
                      color="#2a579a"
                      no-title
                      :readonly="!editing"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-spacer />
                <v-flex xs5>
                  <v-select
                    :items="variancesType.values"
                    label="Typ"
                    v-model="currentVariance.properties.type"
                    :readonly="!editing"
                    :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  ></v-select>

                  <!-- <v-text-field
                    v-model="currentVariance.properties.type"
                    label="Typ"
                    :readonly="!editing"
                  ></v-text-field> -->
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrawp
              >
                <v-flex xs5>
                  <v-select
                    :items="variancesStatus.values"
                    label="Status"
                    v-model="currentVariance.properties.status"
                    :readonly="!editing"
                    :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  ></v-select>
                </v-flex>
                <v-spacer />
              </v-layout>
              <v-layout
                row
                wrawp
              >
                <v-flex xs12>
                  <v-textarea
                    name="description"
                    label="Opis"
                    v-model="currentVariance.properties.description"
                    :readonly="!editing"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-subheader>OBSZAR ROZBIEŻNOŚCI</v-subheader>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                class="geometry-panel"
              >
                <v-flex
                  xs4
                  v-if="!currentVariance.geometry"
                  style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
                >
                  <v-icon
                    class="table__btn--green geometry-panel__add-btn"
                    @click="addGeometry"
                  >add_circle</v-icon>
                  <p
                    @click="addGeometry"
                    class="hover__pointer"
                  >DODAJ GEOMETRIĘ</p>
                </v-flex>
                <v-flex
                  xs4
                  v-else
                  style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
                  :class="{btnDisabled: !editing}"
                >
                  <v-icon
                    :class="{btnDisabled: !editing}"
                    class="table__btn--red geometry-panel__delete-btn"
                    @click="removeGeometry(), removeGeometryLayer()"
                  >delete</v-icon>
                  <p
                    class="hover__pointer"
                    @click="removeGeometry(), removeGeometryLayer()"
                  >USUŃ GEOMETRIĘ</p>
                </v-flex>
                <v-flex xs8>
                  <v-layout
                    justify-space-between
                    id="geometry-panel"
                  >
                    <p
                      v-if="currentVariance.geometry"
                      class="msg--padding"
                    >GEOMETRIA DODANA</p>
                    <p
                      v-else
                      class="msg--padding"
                    >BRAK DODANEJ GEOMETRII</p>
                    <span v-if="currentVariance.geometry">
                      <v-icon
                        title="Przybliż do geometrii"
                        class="geometry-panel__zoom-btn"
                        @click="zoomToInspectionGeom"
                      >zoom_in</v-icon>
                    </span>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card>
          </v-tab-item>

          <!-- No events during adding insepction - that's why (0) -->
          <v-tab v-if="featureEvents != undefined && featureEvents.hasOwnProperty('events')">ZDARZENIA ({{featureEvents.events_count}})</v-tab>
          <v-tab v-else>ZDARZENIA (0)</v-tab>
          <v-tab-item>
            <v-card flat>
              <Events
                style="margin-top: 15px"
                :featureEvents="featureEvents"
                :objectType="objectType"
                :id="currentVariance.id"
              />
            </v-card>
          </v-tab-item>

          <v-tab v-if="attachmentsArr.hasOwnProperty('data')">ZAŁĄCZNIKI ({{attachmentsArr.data.length}})</v-tab>
          <v-tab-item>
            <v-layout row>
              <v-flex xs12>
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
                  <li
                    class="list__container--el"
                    v-for="(index, key) in attachmentsArr.data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename)"
                        small
                        title="Pobierz załącznik"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id)"
                        small
                        title="Usuń załącznik"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
                <AddAttachment
                  v-show="editing"
                  ref="childComponent"
                  @attachmentAdded="updateList"
                  @attachmentDeleted="updateList"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="currentVariance.id"
                  objectType="variances"
                  :auto="true"
                  :module="module"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              v-show="editing"
            >
              <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
            </v-layout>
            <v-layout
              row
              wrap
              style="height: 90%"
              v-show="editing"
            >
              <v-flex
                xs12
                style="height:100%"
              >
                <DatabaseAttachments
                  :objectIdCard="currentVariance.id"
                  :objectTableCard="objectTable"
                  :objectTypeCard="objectType"
                  @attachmentAdded="updateList"
                />
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>

      </v-layout>
    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../../shared/AddAttachment";
import DatabaseAttachments from "../../../table/attachments/DatabaseAttachments";
import Events from "../../../../shared/Events";
import Modal from "../../../../shared/Modal";
import moment from "moment";

export default {
  data: vm => ({
    attachmentsArr: [],
    currentVariance: {},
    dateMenu: false,
    editing: false,
    isDrawing: false,
    module: 'videos', //TODO do zmiany po dodaniu uprawnień na backendzie
    objectTable: "variances",
    objectType: "variances",
    varianceDataCopy: {},
    variancesStatus: {},
    variancesType: {},
  }),
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal
  },
  computed: {
    computedDateFormatted() {
      if(this.currentVariance.properties.hasOwnProperty('created_at')) {
        return this.formatDate(this.currentVariance.properties.created_at.slice(0, 10))
      }
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        }
      })
    },
    user_name() {
      if(this.users) {
        return this.users.find(user => {
          return user.id == this.currentVariance.properties.created_by
        })
      }
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    assignGeomToInspection(polygonData) {
      if(polygonData.length > 1) {
        this.currentVariance.geometry = polygonData[0];
        this.currentVariance.geometry4326 = polygonData[1];
      } else {
        this.currentVariance.geometry4326 = polygonData[0];
      }
    },
    addObjectArea() {
      this.$root.$emit("addObjectArea", this.currentVariance);
    },
    cancelEditing() {
      this.editing = false;
      this.currentVariance = JSON.parse(JSON.stringify(this.varianceDataCopy));
    },
    closed() {
      this.removeGeometryLayer();

      this.$store.commit("setFeatureEvents", undefined);
      this.$store.commit("setCurrentVariance", undefined);
      this.$store.commit("setCurrentVarianceArea", 0);
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    formatDate(date) {
      if(!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    getUsers() {
      this.$store.dispatch("getUsers")
    },
    getVariancesStatus() {
      this.$store.dispatch("getDictSTC", {
        schema: "registry",
        table: "variances",
        column: "status"
      }).then(r => {
        if(!r) {
          return;
        } else {
          this.variancesStatus = r;
        }
      });
    },
    getVariancesType() {
      this.$store.dispatch("getDictSTC", {
        column: "type",
        schema: "registry",
        table: "variances"
      }).then(r => {
        if(r) {
          this.variancesType = r;
        } else {
          console.log(r)
        }
      });
    },
    loadVariance(data) {
      this.currentVariance = data;
    },
    loadData() {
      let splitted_start = this.currentVariance.properties.created_at.slice(0, 10).split("-")
      this.currentVariance.properties.created_at = new Date(splitted_start[0], splitted_start[1] - 1, splitted_start[2]).toISOString().substr(0, 10)
      this.$root.$emit("computeVarianceArea", [
        this.currentVariance.geometry.coordinates
      ]);
      this.id = this.currentVariance.id;
      if(this.currentVariance) {
        let payload = {
          object_type: "variances",
          oid: this.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if(success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }
      //getAttachmentsForObjects
      this.$root.$emit(
        "addMapLayer",
        [this.currentVariance.geometry, this.currentVariance.geometry.coordinates],
        "variance"
      );
      this.zoomToInspectionGeom();
    },
    parseDate(date) {
      if(!date) return null

      const [day, month, year] = date.split('-')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    removeGeometry() {
      if(this.currentVariance) {
        this.currentVariance.geometry = undefined;
      }
    },
    removeGeometryLayer() {
      this.$root.$emit('removeMapLayer')
    },
    removeObjectArea() {
      this.$root.$emit("removeObjectArea");
    },
    saveEditing() {
      // this.$set(this.currentVariance, 'geometry', this.currentVariance['geometry4326'])
      let payload = {
        created_at: this.currentVariance.properties.created_at,
        created_by: this.currentVariance.properties.created_by,
        description: this.currentVariance.properties.description,
        geometry: this.currentVariance.geometry,
        name: this.currentVariance.properties.name,
        status: this.currentVariance.properties.status,
        type: this.currentVariance.properties.type,
      };

      let data = {
        body: payload,
        id: this.currentVariance.id
      };
      this.$store.dispatch("editVariance", data).then(success => {
        if(success) {
          this.editing = false;
          this.$root.$emit("edited_variance")
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas edytowania rozbieżności wystąpił błąd"
          );
          return;
        }
      });
    },
    startEditing() {
      this.editing = true;
      this.varianceDataCopy = JSON.parse(JSON.stringify(this.currentVariance));
    },
    transformPolyCoords() {
      this.$root.$emit('transformPolygon', this.currentVariance.geometry);
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      if(this.currentVariance) {
        let payload = {
          object_type: "variances",
          oid: this.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if(success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }
    },
    zoomToInspectionGeom() {
      this.$root.$emit('zoomToArea', [this.currentVariance.geometry.coordinates]);
    }
  },
  mounted() {
    this.$root.$on("loadVariance", this.loadVariance);
    this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.$root.$on('newGeomAdded', this.assignGeomToInspection);
    this.$root.$on('newpolygonGeom', this.assignGeomToInspection);
    this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
    moment.locale("pl");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/variances/VarianceCard.vue